import React, { useState, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import axios from 'axios';
import { Printer, ArrowLeft } from 'lucide-react';
import EoaEExperience from './EoaEExperience';
import StoryShareButton from './StoryShareButton';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Loader = ({ text }) => (
  <div className="min-h-screen bg-[#050505] flex flex-col items-center justify-center gap-4">
    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#D4AF37]" />
    <p className="font-oswald uppercase tracking-widest text-[#A1A1AA] text-sm">{text}</p>
  </div>
);

// Auth-protected viewer for /eoae/:id and /eoae/:id/print
const EoaEReportPage = () => {
  const { id } = useParams();
  const location = useLocation();
  const printMode = location.pathname.endsWith('/print');
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    axios.get(`${API}/eoae/${id}`)
      .then((res) => setReport(res.data))
      .catch(() => setError('No se pudo cargar el informe.'))
      .finally(() => setLoading(false));
  }, [id]);

  useEffect(() => {
    if (printMode && report) {
      const t = setTimeout(() => window.print(), 900);
      return () => clearTimeout(t);
    }
  }, [printMode, report]);

  if (loading) return <Loader text="Preparando tu informe…" />;
  if (error || !report) {
    return (
      <div className="min-h-screen bg-[#050505] flex items-center justify-center">
        <p className="font-manrope text-red-300">{error || 'Informe no encontrado'}</p>
      </div>
    );
  }

  return (
    <div className="eoae-root bg-[#050505]">
      {!printMode && (
        <div className="no-print fixed top-4 right-4 z-50 flex gap-3">
          <button
            onClick={() => window.history.back()}
            className="flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 backdrop-blur-md text-white text-sm font-manrope hover:bg-white/20 transition"
            data-testid="eoae-back-btn"
          >
            <ArrowLeft className="w-4 h-4" /> Volver
          </button>
          <StoryShareButton report={report} />
          <button
            onClick={() => window.open(`/eoae/${id}/print`, '_blank')}
            className="flex items-center gap-2 px-4 py-2 rounded-full bg-[#D4AF37] text-black text-sm font-semibold font-manrope hover:bg-[#e3c14f] transition"
            data-testid="eoae-print-btn"
          >
            <Printer className="w-4 h-4" /> Exportar PDF
          </button>
        </div>
      )}
      <EoaEExperience report={report} printMode={printMode} />
    </div>
  );
};

export default EoaEReportPage;
